<template>
    <transition name="modal">
        <div class="modal-mask">
            <div class="modal-wrapper" @click="$emit('close')">
                <div class="modal-container" @click.stop="">                    
                    <div ref="modalBody" class="modal-body">
                        <slot name="body">
                            <transition-group :name="animation" class="transition-group">
                                <div v-if="backorder && showStep1" class="step1" key="1">
                                    <p class="choose">{{$root.language.wsm_outOfStockOptions}}</p>
                                    <div class="backorderContent stepContent" @click="backOrderAdd">
                                        <p class="step">1</p>
                                        <div class="stepDescContainer">
                                            <p class="stepDesc">{{$root.language.wsm_AddToBasketModal}}</p>
                                            <p class="contentDesc">{{$root.language.wsm_backOrderDesc}}</p>
                                        </div>
                                    </div>
                                    <div class="getNotifiedContent stepContent" @click="stepForward('notify', 2)">
                                        <p class="step">{{backorder ? '2' : '1'}}</p>
                                        <div class="stepDescContainer">
                                            <p class="stepDesc" v-html="$root.language.wsm_Preorder"></p>
                                            <p class="contentDesc">{{$root.language.wsm_preorderDesc}}</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="step2" v-if="showStep2" :key="2">
                                    <div class="step2Notify" v-if="choice == 'notify'">
                                        <h3><i class='fas fa-bell'></i> {{$root.language.wsm_Preorder}}
                                             </h3>
                                        <p>{{$root.language.wsm_preorderDesc}}</p>
                                    </div>
                                   
                                   <div class="email-container">
                                        <label>{{$root.language.wsm_YourEmail}}</label>
                                        <input type="email" 
                                            v-model="mail" 
                                            :placeholder="$root.language.wsm_YourEmail" 
                                            required                                        
                                            @input="mail"  
                                            :class="(mail !== '' ) && !validEmail ? 'invalidEmail' : ''" />
                                        <p v-if="mail.trim() !== '' && hasSpacesInEmail && showError" class="email-error">{{$root.language.wsm_EmailNoSpaces || 'Email address cannot contain spaces'}}</p>
                                        <p v-else-if="mail.trim() !== '' && !validEmail && showError" class="email-error">{{$root.language.wsm_must_contain_valid_email || 'Please enter a valid email address'}}</p>
                                    
                                    </div>
                                    <br />                                  
                                   
                                   
                                    <div class="newsletter">
                                        <input v-model="newsletterSignUp" id="newsletterChck" type="checkbox" />
                                        <label for="newsletterChck">{{$root.language.wsm_NewsletterOK}} - {{$root.language.wsm_checkOutNewsletterInput}}</label>
                                    </div>
                                    <button :disabled="mail == '' || !validEmail || hasSpacesInEmail" @click.prevent="stepForward(choice, 3)" v-html="$root.language.wsm_Preorder"></button>
                                </div>
                                <div class="step3" v-if="showStep3" :key="3">
                                    <div class="step3Complete">
                                        <svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
                                                                                                                                                                                    <circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none" />
                                                                                                                                                                                    <path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" />
                                                                                                                                                                                </svg>
                                        <transition name="header-fade" :key="4">
                                            <h3 v-if="completed">{{$root.language.wsm_preorderRequestReceived}}</h3>
                                        </transition>
                                        <transition name="header-fade" :key="5">
                                            <button v-if="showCompleteBtn" @click.prevent="$emit('close')">{{$root.language.wsm_ContinueShopping_Checkout}}</button>
                                        </transition>
                                    </div>
                                </div>

                                
                                    
                                <button key="back-btn" class="modal-default-button backBtn" v-if="(currentStep > 1 && currentStep != 3) && (backorder && !preorder)" @click="stepBack(choice, currentStep-1)">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--! Font Awesome Pro 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"/></svg>
                                <!-- <font-awesome-icon icon="arrow-left" />  -->
                                {{$root.language.wsm_Back}}                                                                                                                                                                           </button>
                                   
                                <button key="cancel-btn" v-if="currentStep != 3" class="modal-default-button" @click="$emit('close')">{{$root.language.wsm_Cancel}}</button>
                                
                       
                            </transition-group>
                            
                            <RecommendedAlternatives v-if="productRecommendations.alternateProductRecommText && !isEmptyObject(productRecommendations)" :productRecommendations="productRecommendations"></RecommendedAlternatives>
                        </slot>
                    </div>
                    <div class="modal-footer" v-if="isMobile && productRecommendations.alternateProductRecommText && !isEmptyObject(productRecommendations)">
                        <slot name="footer">
                            <transition name="btn-fade" :key="9">
                                <button class="modal-default-button backBtn" v-if="(currentStep > 1 && currentStep != 3) && (backorder && !preorder)" @click="stepBack(choice, currentStep-1)">
                                    <font-awesome-icon icon="arrow-left" /> {{$root.language.wsm_Back}}
                                </button>
                            </transition>
                            <button :key="10" v-if="currentStep != 3" class="modal-default-button" @click="$emit('close')">{{$root.language.wsm_Cancel}}</button>
                        </slot>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    import RecommendedAlternatives from './recommendedAlternatives.vue'
    export default {
        components: {
            RecommendedAlternatives
        },
        props: ["backorder", "preorder", "productid", "productname"],
        data() {
            return {
                showStep1: true,
                showStep2: false,
                showStep3: false,
                completed: false,
                showCompleteBtn: false,
                currentStep: 1,
                choice: "",
                animation: "slide-fade",
                mail: "",
                newsletterSignUp: false,
                productRecommendations: {},                
                timeout: null,
                showError: false
            };
        },
        created() {           

            let filteredProdcut = this.$root.productdata.data.products[0].products.find(product => product.productId == this.productid);
            this.productRecommendations = filteredProdcut.productRecommendations;
        },
        mounted() {
            window.addEventListener('resize', () => this.$forceUpdate())
            // Prevent body scrolling when modal is open
            document.body.style.overflow = 'hidden';

            if (!this.backorder && this.preorder) {
                this.showStep1 = false;
                this.showStep2 = true;
                this.currentStep = 2;
                this.choice = 'notify'
            }
        },
        beforeDestroy() {
            // Re-enable body scrolling when modal is closed
            document.body.style.overflow = 'auto';
        },
        watch: {
            mail: function(newVal) {
                this.showError = false;
                clearTimeout(this.timeout);
                this.timeout = setTimeout(() => {
                    this.showError = !this.validEmail;
                }, 1000);// user stopped typing
            }
        },
        methods: {
            isEmptyObject(obj) {
                return obj && Object.keys(obj).length === 0 && obj.constructor === Object;
            },
            stepForward: function(typePicked, step) {
                this.animation = "slide-fade";
                switch (step) {
                    //add to basket (backorder) complete
                    case 2:
                        this.showStep1 = false;
                        setTimeout(() => {
                            this.showStep2 = true;
                        }, 310);
                        break;
                    case 3:
                        //preorder complete                       
                        axios.get(
                            window.basedir +`/ajaxRequestServlet?mode=OnStockNotificationAPI&task=subscribeOnStockNotification&newsletterSignUp=${this.newsletterSignUp}&productID=${this.productid}&email=${this.mail.trim()}`,
                            
                            {
                                headers: {
                                    'Content-type': 'application/json',
                                    'Cache-Control': 'no-cache',
                                    'Pragma': 'no-cache',
                                    'Expires': '0',
                                }
                        
                        }).then(response => {
                            this.showStep2 = false;
                            document.getElementsByClassName("modal-body")[0].removeAttribute("style")
                            setTimeout(() => {
                                this.showStep3 = true;
                                setTimeout(() => {
                                    this.completed = true;
                                    setTimeout(() => {
                                        this.showCompleteBtn = true;
                                    }, 400)
                                }, 200);
                            }, 350);
                        })
                }
                this.choice = typePicked;
                this.currentStep = step;
            },
            stepBack: function(typePicked, step) {
                this.animation = "slide-fade2";
                switch (step) {
                    case 3:
                        this.showStep3 = false;
                        setTimeout(() => {
                            this.showStep2 = true;
                        }, 350);
                        break;
                    case 2:
                        this.showStep3 = false;
                        setTimeout(() => {
                            this.showStep2 = true;
                        }, 350);
                        break;
                    case 1:
                        this.showStep2 = false;
                        setTimeout(() => {
                            this.showStep1 = true;
                        }, 315);
                }
                this.choice = typePicked;
                this.currentStep = step;
            },
            backOrderAdd: function() {
                this.$emit('addToBasket');
                this.$emit('close');
            }           
        },
        computed: {
            validEmail: function() {
                this.mail = this.mail.trim();
                // regex to validate email:prevents consecutive dots, does not allow spaces, requires @, and at least s2 letters in the TLD
                
                const regex = /^(?!.*\.\.)[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/;

                return regex.test(this.mail);
            },
            hasSpacesInEmail: function() {
                if (!this.mail || this.mail.trim() === '') {
                    return false;
                }
                // Check for spaces anywhere in the email (between start and end, excluding leading/trailing spaces)
                return this.mail.trim().indexOf(' ') !== -1;
            },
            isMobile: function() {
                return window.innerWidth <= 700;
            }
        },
    };
</script>

<style lang="scss" scoped>
    .modal-mask {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        display: table;
        transition: opacity 0.3s ease;
    }
    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
    }
    .modal-container {     
        width: fit-content;
        min-width: auto;
        margin: 0px auto;
        position: relative;
        //min-height: 480px;
        background-color: #fff;
        border-radius: 2px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
        transition: all 0.3s ease;
        font-family: Helvetica, Arial, sans-serif;

        *{
            box-sizing: border-box;
        }
    }
    .modal-header h3 {
        margin-top: 0;
        color: #004570;
        font-weight: 700;
        font-size: 1.5em;
        padding:1em;
        i {
            color: #004570;
            font-size: 1em;
        }
    }
    .modal-header {
        display:none;   
        padding: 17px;
        border-bottom: 1px solid #d4d4d4;
        p {
            margin-left: 31px !important;
            width: 87%;
            color: #5e5e5e;
        }
    }
    .modal-footer {
        display: block;
        position: relative;
        width: 93%;
        height: 30px;
        padding: 23px;
        padding-top: 0;
        .backBtn {
            float: left;
            i {
                color: white;
                vertical-align: text-bottom;
            }
        }
    }
    .modal-body {      
        display: flex;
        flex-direction: row;
        align-items: center;
        margin: 0;
        padding: 0;

        > * {  // Target direct children
            height: 100%; // Make children fill parent height
            display: flex;
            flex-direction: column;        
        }

        span{
            width: 492px;
            // /min-width: 46%;
            background-color: white;    
            padding: 95px 1px;
            min-height:622px;
        }
        

        &:last-child {
            background-color: #76d7ce1a;
            padding: 0; // Remove default padding
            margin: 0; // Remove margin to extend full height
        }      

        .modal-default-button{
            display: block;
            margin-top: 2%;
            margin: 2% auto 0;
            width: 280px;
        }

       

        h3 {
            color: #004570;
            font-size: 1.5em;
            text-align: center;
            i {
                font-size: 1em;
                color: inherit;
            }
        }
        .step {
            background: white;
            border: 2px solid #7caf63;
            border-radius: 60px;
            display: inline-block;
            min-width: 44px;
            text-align: center;
            color: #7caf63;
            font-size: 2em;
            font-weight: bold;
            transition: all 0.2s ease-in-out;
            margin-left: -44px;
            margin-top: -6px;
        }
        .step1 {
            margin-top: 34px;
        }
        .choose {
            font-size: 1.2em;
            margin-left: 23px;
        }
        .stepDesc {
            display: inline-block;
            font-size: 1.4em;
            margin-left: 5px;
            font-weight: bold;
            color: #7caf63;
            text-transform: uppercase;
        }
        .contentDesc {
            font-size: 1.2em;
            color: #606060;
            margin-left: 8px;
        }
        .stepContent {
            margin-top: 17px;
            margin-bottom: 28px;
            padding: 20px;
            border: 2px solid white;
            transition: all 0.2s ease-in-out;
            margin-left: 15px;
            &:hover {
                cursor: pointer;
            }
        }
        .step3 {
            h3 {
                font-weight: bold;
                width: 80%;
                margin: 0 auto;
                margin-top: 20px;
                font-size: 1.5em;
                color: #7ac142;
            }
            button {
                background: #004570;
                border: none;
                color: white;
                padding: 10px;
                font-size: 1.2em;
                border-radius: 4px;
                display: block;
                margin: 0 auto;
                margin-top: 36px;
                cursor: pointer;
            }
        }
        .stepDescContainer {
            margin-left: 14px;
            margin-top: 1px;
            display: inline-block;
            width: 94%;
            vertical-align: top;
        }
        .getNotifiedContent {
            border: 2px solid #63afad;
            h3 {
                color: #63afad;
            }
            .step {
                border-color: #63afad;
                color: #63afad;
            }
            .stepDesc {
                color: #63afad;
            }
            &:hover {
                background: #cff3f2;
                .step {
                    background: #63afad;
                    color: white;
                }
            }
        }
        .backorderContent {
            border: 2px solid #7caf63;
            &:hover {
                background: #d9f2cd;
                .step {
                    background: #7caf63;
                    color: white;
                }
            }
        }
        .step2 {
            margin: 0 auto;
            display: block;
            padding: 20%;
            padding-top: 0;
            padding-bottom: 9px;
            position: relative;
            &>div {
                margin-top: 10px;
                margin-bottom: 31px;
                p {
                    text-align: center;
                }
                h3 {
                    font-weight: bold;
                    font-size: 2em;
                }
            }

            input[type="email"] {
                margin-bottom: 0 !important;
            }

            .invalidEmail {
                border: 1px solid red !important;
                //margin-bottom:0 !important;
            }

            .email-error {
                display: block;
                color: red;
                font-size: 0.9em;
                margin-top: 5px;
                text-align: left;
                position: absolute;
                width:60%;
                padding:0; 
                margin-left: 2%;
                                
            }

            button {
                font-family: Helvetica, Arial, sans-serif; 
                background: #7caf63;
                border: none;
                color: white;
                padding: 10px;
                font-size: 1.2em;
                border-radius: 4px;
                display: block;
                margin: 0 auto;
                margin-top: 36px;
                cursor: pointer;
                &:disabled {
                    background: #6e6e6e;
                    opacity: 0.6;
                    &:hover {
                        background: #6e6e6e;
                    }
                }
                &:hover {
                    background: #97c580;
                }
            }
            .newsletter {
                text-align: left;
                width: 92%;
                margin: 0 auto;
                margin-top: 31px;
                input {
                    display: inline-block;
                    vertical-align: top;
                    padding-right: 20px;
                    margin-right: 8px;
                }
                label {
                    display: inline-block;
                    text-align: left;
                    width: 90%;
                    cursor: pointer;
                }
            }
            input[type="text"],
            input[type="email"] {
                border-radius: 4px;
                font-size: 1.2em;
                transition: all 0.2s ease-in-out;
                //width: 85%;
                text-align: center;
                padding: 10px;
                max-width: unset;
                color: #004570;
                margin: 0 auto;
                &:hover {
                    border: 1px solid #004570;
                }
                &:focus {
                    border: 1px solid #004570;
                }
            }
            label {
                display: none;
            }
            .step2Backorder {
                h3 {
                    color: #7caf63;
                }
                p {
                    color: #878f83;
                }
            }
            .step2Notify {
                h3 {
                    color: #63afad;
                }
                p {
                    color: #9db0b0;
                }
            }
        }
    }
    .modal-default-button { 
        font-family: Helvetica, Arial, sans-serif; 
        background: none;
        color: black;
        font-weight: bold;
        padding: 9px;
        border-radius: 4px;
        cursor: pointer;
        border: none;
        &:hover {
            background: none;
            text-decoration: underline;
        }
    }
    /*
                                                                                                                                         * The following styles are auto-applied to elements with
                                                                                                                                         * transition="modal" when their visibility is toggled
                                                                                                                                         * by Vue.js.
                                                                                                                                         *
                                                                                                                                         * You can easily play with the modal transition by editing
                                                                                                                                         * these styles.
                                                                                                                                         */
    .modal-enter {
        opacity: 0;
    }
    .modal-leave-active {
        opacity: 0;
    }
    .modal-enter .modal-container,
    .modal-leave-active .modal-container,
    .modal-leave-active {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }
    /* Enter and leave animations can use different */
    /* durations and timing functions.              */
    .slide-fade-enter-active,
    .slide-fade-leave-active,
    .slide-fade2-enter-active,
    .slide-fade2-leave-active,
    .btn-fade-enter-active,
    .btn-fade-leave-active {
        transition: all 0.3s ease;
    }
    .header-fade-enter-active,
    .header-fade-leave-active {
        transition: all 1s ease;
    }
    .slide-fade-leave-to
    /* .slide-fade-leave-active below version 2.1.8 */
    {
        transform: translateX(-10px);
        opacity: 0;
    }
    .slide-fade-enter
    /* .slide-fade-leave-active below version 2.1.8 */
    {
        transform: translateX(10px);
        opacity: 0;
    }
    .slide-fade2-leave-to
    /* .slide-fade-leave-active below version 2.1.8 */
    {
        transform: translateX(10px);
        opacity: 0;
    }
    .slide-fade2-enter
    /* .slide-fade-leave-active below version 2.1.8 */
    {
        transform: translateX(-10px);
        opacity: 0;
    }
    .btn-fade-leave-to
    /* .slide-fade-leave-active below version 2.1.8 */
    {
        transform: translateY(10px);
        opacity: 0;
    }
    .btn-fade-enter
    /* .slide-fade-leave-active below version 2.1.8 */
    {
        transform: translateY(10px);
        opacity: 0;
    }
    .header-fade-leave-to
    /* .slide-fade-leave-active below version 2.1.8 */
    {
        transform: translateY(10px);
        opacity: 0;
    }
    .header-fade-enter
    /* .slide-fade-leave-active below version 2.1.8 */
    {
        transform: translateY(10px);
        opacity: 0;
    } // Colors

    $green_backorder: #7ac142;
    $white: #fff; // Misc
    $curve: cubic-bezier(0.65, 0, 0.45, 1);
    .step3Complete {
        .checkmark {
            width: 56px;
            height: 56px;
            margin: 0 auto;
            margin-top: 50px;
            border-radius: 50%;
            display: block;
            stroke-width: 2;
            stroke: $white;
            stroke-miterlimit: 10;
            box-shadow: inset 0px 0px 0px $green_backorder;
            animation: fill 0.4s ease-in-out 0.4s forwards, scale 0.3s ease-in-out 0.9s both;
        }
        .checkmark__circle {
            stroke-dasharray: 166;
            stroke-dashoffset: 166;
            stroke-width: 2;
            stroke-miterlimit: 10;
            stroke: $green_backorder;
            fill: none;
            animation: stroke 0.6s $curve forwards;
        }
        .checkmark__check {
            transform-origin: 50% 50%;
            stroke-dasharray: 48;
            stroke-dashoffset: 48;
            animation: stroke 0.3s $curve 0.8s forwards;
        }
    }
    
    @keyframes stroke {
        100% {
            stroke-dashoffset: 0;
        }
    }
    @keyframes scale {
        0%,
        100% {
            transform: none;
        }
        50% {
            transform: scale3d(1.1, 1.1, 1);
        }
    }
    @keyframes fill {
        100% {
            box-shadow: inset 0px 0px 0px 30px $green_backorder;
        }
    }
    @media screen and (max-width: 1366px) {
        .modal-container {
            max-width: 90%;   
            max-height: 85vh;           
            overflow-y: auto;

            .modal-body {   
                .recommended-alternatives {
                    padding: 5% 7%;
                    height: auto;
                    text-align: center;
                }
            }  
        }
    }

    @media screen and (max-width: 1024px) {
        .modal-container {
            .modal-body {
                flex-direction: column;

                span {
                    width: 100%;
                    min-height: auto;
                    padding: 50px 0;
                }

                .recommended-alternatives {
                    overflow-y: unset;
                    max-height: 100%;
                    padding: 5% 7%;
                    width: 100%;
                }
            }
        }
    }

    @media screen and (max-width: 900px) {
        .modal-container {
            overflow-y: auto;
            min-height: 86vh;
        }
    }
    
    @media screen and (max-width: 700px) {
        .modal-container {  
            flex-direction: column;
           // min-height: 447px;
            max-height: 90vh;
            margin:0 auto;
            border-radius: 0;
            
            .stepDesc {
                font-size: 1em;
            }
            .contentDesc {
                font-size: 0.8em;
            }
            .stepDescContainer {
                width: 86%;
            }
        }
        .modal-body {   
            span{
                padding: 20px 0;
            }
            
            .stepContent {
                padding-top: 7px;
                margin-left: 6px;
                padding-bottom: 10px;
            }
            .step {
                font-size: 1.4em;
                min-width: 29px;
                margin-left: -37px;
                margin-top: 6px;
            }
            .choose {
                margin: 0;
                text-align: center;
            }
            .step1 {
                margin-top: 15px;
                padding: 0;
            }
            .step2 {
                margin-top: 15px;
                padding: 15px;
                
                button {
                    font-family: Helvetica, Arial, sans-serif; 
                    min-width: 91%;
                    margin-bottom: 20px;
                }
                .newsletter {
                    label {
                        width: 86%;
                        font-size: 0.8em;
                    }
                }
                .step2Notify {
                    font-size: 0.8em;

                    h3{
                        margin: 0 10%;
                    }
                }

                .email-container {
                    width:90%;
                    margin-left: 2%;
                }
            }

            .modal-default-button{
                width: 91%;
            }

            .step3 {
                h3 {
                    width: 85%;
                }
            }
        }
        .modal-footer {
            box-sizing: border-box;
            width: 100%;
            position: relative;
            height: 66px;
            padding: 14px;
           
            .modal-default-button{
                width: 91%;
                display: block;
                margin: 1% auto 6%;
            }
        }
    }
</style>
